import { Component, type ErrorInfo, type ReactNode } from 'react';

import { routes } from '@/config/routes';

type AppErrorBoundaryState = { hasError: boolean };

export class AppErrorBoundary extends Component<{ children: ReactNode }, AppErrorBoundaryState> {
  override state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.DEV) console.error('Unexpected application error', error, info);
  }

  override render() {
    if (this.state.hasError) {
      return (
        <main className="fatal-error">
          <div className="state-card">
            <i className="pi pi-exclamation-circle" aria-hidden="true" />
            <h1>We hit an unexpected snag</h1>
            <p>Your ideas are safe. Return home and try that step again.</p>
            <a className="button-link button-link--primary" href={routes.home}>
              Return home
            </a>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}
